export default __webpack_public_path__ + "static/media/Stoll.42fb2f19.png";